<!--
 * @Description: -设备OEE TOP10
 * @Autor: xiaona.wang
 * @Date: 2021-12-14 20:56:34
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-07-06 18:54:18
-->
<template>
  <div class="chart-warp">
    <div class="tab_wrap">
      <span class="tab_button" :class="{ bgColor: timeFilterType === 'NEARLY' }" @click="buttonClick('NEARLY')">近30天</span>
      <span class="tab_button" :class="{ bgColor: timeFilterType === 'CURRENT_MONTH' }" @click="buttonClick('CURRENT_MONTH')">本月</span>
    </div>
    <div id="part_used_number_top10" class="box_conetnt"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import cockpitApi from "@/api/cockpit/cockpit";
import resize from "./mixins/resize";

export default {
  name: "PartUsedNumberTop10",
  mixins: [resize],
  data() {
    return {
      chart: null,
      timeFilterType: "NEARLY"
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getPartUsedNumberTop10();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    resizeSetData() {
      setTimeout(() => {
        this.chart && this.chart.resize();
      }, 200);
    },
    buttonClick(type) {
      this.timeFilterType = type;
      this.getPartUsedNumberTop10(type);
    },
    getPartUsedNumberTop10(type = "NEARLY") {
      cockpitApi.getPartUsedNumberTop10({ searchType: type }).then(result => {
        if (result.code === 200 && result.success) {
          const echartsName = [];
          const echartsValue = [];

          result.data.map(item => {
            echartsName.push(item.materialName);
            echartsValue.push(item.actualQuantity);
          });
          this.drawPartUsedNumberTop10(echartsName, echartsValue);
        }
      });
    },
    // 备件使用数量TOP10
    drawPartUsedNumberTop10(echartsName, echartsValue) {
      this.chart = echarts.init(document.getElementById("part_used_number_top10"));
      this.chart.setOption({
        title: {
          text: "备件使用数量TOP10"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          top: "50px",
          left: "8",
          right: "30",
          bottom: "10px",
          containLabel: true
        },
        xAxis: {
          type: "value",
          axisLine: {
            show: true,
            lineStyle: {
              type: "solid", // x轴线条类型
              color: "#EEE", // x轴线条颜色
              width: "1" // x轴线条宽度
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#F0F0F0"
            }
          },
          axisLabel: {
            textStyle: {
              color: "#595959" // x轴文本颜色
            }
          }
        },
        yAxis: {
          type: "category",
          name: "备件",
          inverse: true,
          nameTextStyle: {
            color: "#21252E",
            padding: [0, 0, -10, 10]
          },
          data: echartsName,
          // data: ["备件1", "备件2", "备件3", "备件4", "备件5", "备件6", "备件7"],

          axisLine: {
            show: true,
            lineStyle: {
              type: "solid", // x轴线条类型
              color: "#EEE", // x轴线条颜色
              width: "1" // x轴线条宽度
            }
          },
          axisLabel: {
            textStyle: {
              color: "#595959" // x轴文本颜色
            }
          }
        },
        series: [
          {
            data: echartsValue,
            // data: [120, 200, 150, 80, 70, 110, 130],
            type: "bar",
            barWidth: 10,
            itemStyle: {
              normal: {
                color: "#52C6BE"
              }
            }
          }
        ]
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.chart-warp{
  width:100%;
  height:100%;
  padding:24px 24px 16px;
}
.box_conetnt{
  width:100%;
  height:100%;
}
.tab_wrap {
  position: absolute;
  text-align: center;
  color: #5b5b5c;
  right: 36px;
  top: 16px;
  z-index: 99;
  .tab_button {
    display: inline-block;
    width: 80px;
    height: 28px;
    line-height: 28px;
    background-color: #f5f7fa;
    color: #505363;
  }
  .bgColor {
    background-color: #00b259;
    color: #fff;
  }
}
</style>
